import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "8", height: "14", x: "8", y: "6", rx: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m19 7-3 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m5 7 3 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m19 19-3-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m5 19 3-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 13h-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 13h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m10 4 1 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14 4-1 2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Bug";
const Bug = memo(themed(Icon));
export {
  Bug
};
//# sourceMappingURL=bug.js.map
